type OneClickPurchaseEventCartAttributes = {
  testOrder    : string,
  templateID   : string,
  cartPlatform : string,
  couponApplied: string,
  currency     : string,
}

type OneClickPurchaseEventTransactionAttributes = Omit< OneClickPurchaseEventCartAttributes, 'couponApplied'> & {
  purchaseCompleted: string,
  paymentPlatform  : string,
  paymentType      : string,
  paymentMethod    : string
}

type OneClickPurchaseEventCartTotal = {
  basePrice    : number,
  discountValue: number,
  price        : number,
  grossPrice   : number
}

type OneClickPurchaseEventTransactionTotal = OneClickPurchaseEventCartTotal & {
  taxValue     : number,
  shippingValue: number,
}

type OneClickPurchaseEventCartProduct = {
  info: {
    ID              : string,
    name            : string,
    devices         : number | string,
    version         : number | string,
    subscription    : number,
    subscriptionType: string,
    quantity        : number | string,
    basePrice       : number | string,
    discountValue   : number | string,
    discountRate    : number,
    price           : number | string,
    grossPrice      : number | string,
    discountCupon   : string
  }[]
}

export type OneClickPurchaseEventCartObject = {
  ID         : string,
  attributes : OneClickPurchaseEventCartAttributes,
  total     ?: OneClickPurchaseEventCartTotal,
  product   ?: OneClickPurchaseEventCartProduct
} | null

export type OneClickPurchaseEventTransactionObject = {
  ID         : string,
  attributes : OneClickPurchaseEventTransactionAttributes,
  total     ?: OneClickPurchaseEventTransactionTotal,
  product   ?: OneClickPurchaseEventCartProduct
} | null